export class ConfigValidationError extends Error {
    issues;
    constructor(message, issues) {
        super(message);
        this.issues = issues;
        this.name = 'ConfigValidationError';
    }
}
export class MissingEnvironmentError extends Error {
    constructor(environment) {
        super(`Environment "${environment}" is not supported. Must be one of: local, staging, production`);
        this.name = 'MissingEnvironmentError';
    }
}
export class MissingSecretError extends Error {
    constructor(secretName) {
        super(`Missing required secret: ${secretName}`);
        this.name = 'MissingSecretError';
    }
}
export function formatValidationError(error) {
    if (error.issues) {
        const issues = error.issues
            .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
            .join('\n');
        return `Configuration validation failed:\n${issues}`;
    }
    return error.message || 'Unknown validation error';
}
